import { render, staticRenderFns } from "./eventDetailBox.vue?vue&type=template&id=cc3d4814"
import script from "./eventDetailBox.vue?vue&type=script&lang=js"
export * from "./eventDetailBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports